import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrdersService} from "../../../../shared/services/orders.service";
import {interval, retry, Subscription, switchMap, take} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {NewCartOrderStatus} from "../../../../shared/enum/new-cart-order-statss";

@Component({
  selector: 'app-loading-with-image-modal',
  templateUrl: './loading-with-image-modal.component.html',
})
export class LoadingWithImageModalComponent implements OnInit, OnDestroy {
  faSpinner = faSpinner;
  message: string = '';
  title: string = '';
  img: string = '';
  orderId: string;
  checkTimer$: Subscription | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LoadingWithImageModalComponent>,
    private readonly _orderService: OrdersService,
  )
  {
    this.message = data.message;
    this.title = data.title;
    this.img = data.img;
    this.orderId = data.orderId || null;
  }

  ngOnInit(): void {
    if (!!this.orderId) this.checkOrderStatus();
  }

  checkOrderStatus() {
     this.checkTimer$ = interval(20000)
      .pipe(
        take(3),
        switchMap(() => this._orderService.getServiceApiOrderDetails(this.orderId)
          .pipe(retry(environment.retry_on_fail))
        )
      )
      .subscribe(resp => {
        if (NewCartOrderStatus.UserStoreOrderPendingPaymentStatus != resp?.data?.storeOrderStatusName) {
          console.log("Orden pagada, cerrando modal desde adentro", "orderStatus: ", resp?.data?.storeOrderStatusName, "orderId: ", this.orderId);
          this.checkTimer$?.unsubscribe();
          this.dialogRef.close();
        }
      });
  }

  ngOnDestroy() {
    this.checkTimer$?.unsubscribe();
  }
}
